<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>账号管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :model="formInline" class="searchBar">
      <el-row>
        <el-col :span="8">
          <el-form-item label="姓名">
            <el-input
              size="small"
              v-model="formInline.realName"
              placeholder="输入姓名"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="状态">
            <el-select
              size="small"
              v-model="formInline.status"
              placeholder="请选择状态"
            >
              <el-option label="空" value="0"></el-option>
              <el-option label="正常" value="1"></el-option>
              <el-option label="冻结" value="2"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="部门">
            <el-cascader
              :options="deptCols"
              filterable
              clearable
              :props="deptProps"
              size="small"
              @change="handleSelectDept"
            ></el-cascader>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <el-form-item>
            <el-button
              size="small"
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >搜索</el-button
            >
            <el-button
              size="small"
              type="info"
              icon="el-icon-delete"
              @click="handleReset"
              >清空</el-button
            >
            <el-button
              size="small"
              v-hasPerm="btn_perm_type.account.add"
              icon="el-icon-plus"
              @click="handleEdit()"
              >新增</el-button
            >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!--列表-->
    <el-table
      size="small"
      :data="userData"
      highlight-current-row
      v-loading="loading"
      border
      element-loading-text="拼命加载中"
      style="width: 100%"
    >
      <el-table-column align="center" type="index" width="50">
      </el-table-column>
      <el-table-column align="center" sortable prop="realName" label="用户名">
      </el-table-column>
      <el-table-column align="center" sortable prop="nickName" label="用户昵称">
      </el-table-column>
      <el-table-column align="center" sortable prop="deptName" label="部门">
      </el-table-column>
      <el-table-column align="center" sortable prop="phone" label="手机号">
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="registerTime"
        label="创建时间"
        :formatter="handleFormatDate"
      >
      </el-table-column>
      <el-table-column
        align="center"
        sortable
        prop="status"
        label="状态"
        :formatter="handleFormatStatus"
      >
      </el-table-column>
      <el-table-column label="操作" width="240" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.account.update"
            type="primary"
            @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <!-- 冻结 2  解冻 1  -->
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.account.update"
            :type="scope.row.status === 0 ? 'info' : 'success'"
            @click="handleStatus(scope.row, scope.row.status === 0 ? 1 : 3)"
            >{{ (scope.row.status ^ 3) | formatStatus }}</el-button
          >
          <el-button
            size="mini"
            v-hasPerm="btn_perm_type.account.delete"
            type="danger"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination :pager="pager" @pager="handlePager"></Pagination>
    <!-- 编辑界面 -->
    <EditForm
      :title="title"
      :visible.sync="editFormVisible"
      :editForm="editForm"
      @confirm="handleEditForm"
    ></EditForm>
  </div>
</template>

<script>
// 导入请求方法
import { listUser, delUser, saveOrUpdateUser } from "@/api/system/user";
import { selectDept } from "@/api/system/dept";
import Pagination from "@/components/pagination";
import EditForm from "./add-edit";
import Company from "@/components/company";
import { toTree, timestampToDate } from "@/utils";
import { BTN_PERMS_TYPE } from "@/utils/permissions";

function formatStatus(val) {
  if (val) {
    return val === 1 || val === 3 ? "正常" : "冻结";
  }

  return "匿名用户";
}
export default {
  filters: {
    formatStatus(val) {
      return formatStatus(val);
    },
  },
  data() {
    return {
      btn_perm_type: BTN_PERMS_TYPE,
      editFormVisible: false,
      loading: false,
      title: "添加用户",
      deptProps: {
        value: "id",
        label: "deptName",
        children: "children",
      },
      deptCols: [],
      editForm: {
        realName: "",
        nickName: "",
        registerTime: "",
        deptId: "",
        status: "",
        phone: "",
      },
      formInline: {
        realName: "",
        status: "",
        dept: {
          id: "",
        },
      },
      userData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 1,
      },
    };
  },
  components: {
    Pagination,
    EditForm,
    Company,
  },
  created() {
    this.getData();
    this.getDept();
  },
  methods: {
    handleFormatDate(row, column, cellValue) {
      if (cellValue) {
        return timestampToDate(cellValue);
      }

      return cellValue;
    },
    handleFormatStatus(row) {
      return formatStatus(row.status);
    },
    getDept() {
      selectDept({ type: "USER" }).then((data) => {
        this.deptCols = toTree(data, 0);
      });
    },
    getData() {
      this.loading = true;
      listUser(this.pager.currentPage, this.pager.pageSize, this.formInline)
        .then(({ content, page, size, totalCount }) => {
          this.userData = content;
          this.pager.currentPage = page;
          this.pager.pageSize = size;
          this.pager.total = totalCount;
        })
        .catch(this.$message.error)
        .finally(() => {
          this.loading = false;
        });
    },
    handlePager(pager) {
      this.pager.currentPage = pager.currentPage;
      this.pager.pageSize = pager.pageSize;
      this.getData();
    },
    handleSearch() {
      this.getData();
    },
    handleReset() {
      this.formInline = {
        nickName: "",
        status: "",
        dept: {
          id: "",
        },
      };
      this.getData();
    },
    handleEdit(row) {
      if (row) {
        this.title = "修改用户";
        this.editForm = row;
      } else {
        this.title = "添加用户";
        this.editForm = {};
      }
      this.editFormVisible = true;
    },
    handleStatus(row, status) {
      let oriRowStatus = row.status;
      // 状态 0 匿名账号  1 正常  2 冻结
      row.status = row.status ^ status;
      saveOrUpdateUser(row)
        .then(() => {
          this.$message({
            message: "操作成功",
            type: "success",
          });
          this.getData();
        })
        .catch((err) => {
          row.status = oriRowStatus;
          this.$message.error(err);
        });
    },
    handleDelete(row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (row.status === 1) {
            this.$message.warning("正在使用，无法删除");
          } else {
            delUser(row.id)
              .then(() => {
                this.$message({
                  type: "success",
                  message: "操作成功!",
                });
                this.getData();
              })
              .catch(() => {
                this.$message.error("数据删除失败，请稍后再试！");
              });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },
    handleEditForm() {
      this.getData();
    },
    handleSelectDept(data) {
      this.formInline.dept.id = data.slice(-1)[0];
    },
  },
};
</script>

<style scoped>
.el-input {
  width: auto !important;
}
.searchBar {
  margin-top: 20px;
  height: 50px;
}
</style>




// WEBPACK FOOTER //
// src/views/system/account/index.vue